import React from "react";
import { Button, Col, Form, Modal, Row, Spin, Typography } from "antd";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import IndexTypeCategoriesGrid from "../components/IndexTypeCategoriesGrid";
import { ICategoryIndexBulkEditorPresenter } from "../../presenter/CategoryIndexBulkEditorPresenter";
import OrganisationCheckboxGroup from "../../../search/ui/components/criteria/OrganisationCheckboxGroup";
import FormSection from "../../../core/ui/components/FormSection";
import IndexSelectionTree from "../../../search/ui/components/criteria/IndexSelectionTree";
import { PlusOutlined } from "@ant-design/icons";
import Input from "antd/lib/input/Input";
import BulkEditorFormModal from "../components/BulkEditorFormModal";

export interface Props extends PageProps {}

export interface State extends ICategoryIndexBulkEditorPresenter {}

export default class CategoryBulkEditorPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      organisations,
      onSelectOrganisations,
      selectedOrganisationIds,
      selectedOrganisationIdStrings,
      selectedIndexTrees,
      onSelectTreeItem,
      treeSelection,
      groupTypeCandidates,
      indexTypeCandidates,
      groupEditorModalVisible,
      saveGroupChanges,
      onNewIndexGroup,
      onNewIndex,
      closeGroupEditorModal,
      closeIndexEditorModal,
      indexEditorModalVisible,
      modalTitle,
      onGroupNameTextChange,
      saveIndexChanges,
      onIndexNameTextChange
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <>
            <Typography.Title style={{ fontSize: 20 }}>
              {translate("category_bulk_editor.title")}
            </Typography.Title>
            <Row>
              <Col xs={24} sm={24}>
                <FormSection
                  offset={0}
                  compact
                  collapsible
                  collapsed={false}
                  title={translate(
                    "category_bulk_editor.select_organisations_title"
                  )}
                  subtitle={""}
                >
                  <Spin spinning={this.state.loaders.organisationLoader}>
                    <OrganisationCheckboxGroup
                      selectedOrganisations={selectedOrganisationIdStrings}
                      horizontal={true}
                      organisations={organisations}
                      translate={translate}
                      onChange={onSelectOrganisations}
                    />
                  </Spin>
                </FormSection>
              </Col>
            </Row>
            {indexTypeCandidates || groupTypeCandidates ? (
              <Row
                justify="end"
                gutter={[16, 16]}
                style={{ paddingTop: 16, paddingBottom: 16 }}
              >
                {groupTypeCandidates?.map((item) => (
                  <Col key={`group-type-${item.id}`}>
                    <Button
                      onClick={(e) => onNewIndexGroup(item)}
                      icon={<PlusOutlined />}
                    >
                      {item.name}
                    </Button>
                  </Col>
                ))}
                {indexTypeCandidates?.map((item) => (
                  <Col key={`index-type-${item.id}`}>
                    <Button
                      onClick={(e) => onNewIndex(item)}
                      icon={<PlusOutlined />}
                    >
                      {item.name}
                    </Button>
                  </Col>
                ))}
              </Row>
            ) : null}
            <Row>
              <Col xs={24} sm={24}>
                <FormSection
                  offset={0}
                  compact
                  collapsible
                  collapsed={false}
                  title={translate("category_bulk_editor.select_indexes_title")}
                  subtitle={""}
                >
                  <Spin spinning={this.state.loaders.indexLoader || false}>
                    <Row justify="space-between">
                      {Object.entries(selectedIndexTrees || {}).map(
                        (item, index) => (
                          <Col
                            key={`connected-tree-${item[0]}`}
                            style={{ maxWidth: "25%", overflow: "auto" }}
                          >
                            <Typography.Title level={5}>
                              {
                                organisations?.find(
                                  (org) => org.id.toString() == item[0]
                                )?.name
                              }
                            </Typography.Title>
                            <IndexSelectionTree
                              searchVisible={false}
                              checkable={false}
                              selectable
                              loading={this.state.loaders.indexLoader}
                              translate={translate}
                              indexTrees={[item[1]]}
                              onCheck={function (
                                checkedItems: string[]
                              ): void {}}
                              onSelect={(keys, info) => {
                                onSelectTreeItem(info.node);
                              }}
                              selectedKeys={[
                                treeSelection?.[item[0]]?.toString() || ""
                              ]}
                            />
                          </Col>
                        )
                      )}
                    </Row>
                  </Spin>
                </FormSection>
              </Col>
            </Row>
          </>
        }
        <BulkEditorFormModal
          loading={this.state.loaders.saveChanges}
          modalVisible={groupEditorModalVisible || false}
          title={modalTitle || ""}
          okText={translate("data_grid.modal.actions.save")}
          cancelText={translate("data_grid.modal.actions.cancel")}
          onCancel={closeGroupEditorModal}
          onOK={saveGroupChanges}
          selectedOrganisationIds={selectedOrganisationIds}
          organisations={organisations}
          prefix="group"
          onTextValueChange={onGroupNameTextChange}
        ></BulkEditorFormModal>
        <BulkEditorFormModal
          loading={this.state.loaders.saveChanges}
          modalVisible={indexEditorModalVisible || false}
          title={modalTitle || ""}
          okText={translate("data_grid.modal.actions.save")}
          cancelText={translate("data_grid.modal.actions.cancel")}
          onCancel={closeIndexEditorModal}
          onOK={saveIndexChanges}
          selectedOrganisationIds={selectedOrganisationIds}
          organisations={organisations}
          prefix="idx"
          onTextValueChange={onIndexNameTextChange}
        ></BulkEditorFormModal>
      </Page>
    );
  }
}
